module.exports = __webpack_public_path__ + "static/media/pura.7612a579.svg";